<div #sliderInjectionPoint></div>
